import {Injectable} from '@angular/core';
import {URLSearchParams} from '@angular/http';
import {CookieService} from 'ngx-cookie';
import {ConfigService} from '../../config/config.service';
import {ActivatedRoute} from '@angular/router';
import {SessionService} from "./session.service";
import {httpExtensionService} from "./httpextension.service";

const EXPIRATION_HOURS = 2;

@Injectable()
export class CommonDataService {
    genders: Array<string> = ['male', 'female'];

    // months array
    months: Array<string> = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'FeDecemberbruary'
    ];

    statusesDropdown = [
        {
                val: 'AwaitingPayment',
                label: 'Awaiting Payment'
        },
        {
                val: 'Pending',
                label: 'Pending'
        },
        {
                val: 'InProduction',
                label: 'In Production'
        },
        {
                val: 'ReadyForPickup',
                label: 'Ready For Pickup'
        },
        {
                val: 'PartiallyShipped',
                label: 'Partially Shipped'
        },
        {
                val: 'Shipped',
                label: 'Shipped'
        },
        {
                val: 'Completed',
                label: 'Completed'
        },
        {
                val: 'Canceled',
                label: 'Canceled'
        },
        {
                val: 'ShippedReadyForPickup',
                label: 'Shipped Ready For Pick Up'
        }

    ];

    constructor(private _cookieService: CookieService,
                private configService: ConfigService,
                private activatedRoute: ActivatedRoute,
                private sessionService: SessionService,
                private http: httpExtensionService) {}

    // whoever reads this - PLEASE forgive me!!! Nikifor Penkov 23.03.2017
    checkMarket() {
        let market = null;
        if (this.configService.isQA) {
            let tmp = this.activatedRoute.snapshot.queryParams['market'];
            if (tmp) {
                've' === tmp ? market = 'VENTURA_MARKET' : 'sb' === tmp ? market = 'SANTA_BARBARA_MARKET' : market = tmp;
            } else {
                've' === this.configService.market ? market = 'VENTURA_MARKET' :
                    'sb' === this.configService.market ? market = 'SANTA_BARBARA_MARKET' : market = this.configService.market;
            }
        } else {
            've' === this.configService.market ? market = 'VENTURA_MARKET' :
                'sb' === this.configService.market ? market = 'SANTA_BARBARA_MARKET' : market = this.configService.market;
        }

        return market;
    }

    activeMarketsFilterObject: any = {
        paging: {
            page: 1,
            numRows: 0
        },
        filter: {
            fields: [{
                field: "status",
                value: "ACTIVE",
                operation: "EQUAL"
            }]
        }
    };

    allMarketsFilterObject: any = {
        paging: {
            page: 1,
            numRows: 0
        }
    };

    activeMarkets: any[] = [];
    allMarkets: any[] = [];

    setActiveMarkets(activeMarkets) {
        this.activeMarkets = activeMarkets;
    }

    setAllMarkets(allMarkets) {
        this.allMarkets = allMarkets;
    }

    modifyToSelectItems(markets) {
        const selectItems = [];
        markets.forEach(market => {
            let marketName = '';
            if (market.name === 'SANTA_BARBARA_MARKET') {
                marketName = 'Santa Barbara';
            } else if (market.name === 'VENTURA_MARKET') {
                marketName = 'Ventura';
            } else {
                marketName = market.name;
            }
            selectItems.push({
                label: ' ' + marketName,
                value: market.name,
                id: market.id,
                status: market.status
            });
        });
        selectItems.sort(this.sortValuesAlphabetically);
        return selectItems;
    }

    sortValuesAlphabetically(a, b) {
        if (a.value < b.value)
            return -1;
        if (a.value > b.value)
            return 1;
        return 0;
    }

    publicMarketsList() {
        return this.http.get(this.configService.publicMarketsList);
    }

    private getToken() {
        let user_token;
        if (this.sessionService.checkSessionCookie() !== undefined) {
            user_token = this.sessionService.checkSessionCookie();
        } else if (this.sessionService.checkStorageSession() != null) {
            user_token = this.sessionService.checkStorageSession();
        }

        return user_token;
    }

    checkYear() {
        let year = null;
        if (this.configService.isQA) {
            let tmp = this.activatedRoute.snapshot.queryParams['year'];
            if (tmp) {
                '2018' === tmp ? year = 2018 : year = 2019;
            } /*else {
                2018 === this.configService.year ? year = 2018 : year = 2019;
            }*/
        } /*else {
            2018 === this.configService.year ? year = 2018 : year = 2019;
        }*/

        return year;
    }

    // get range of years from starting year
    iterateBDayYears(startDate): Array<number> {
        let years: Array<number> = [];
        for (let i = startDate; i <= new Date().getFullYear(); i++) {
            years.push(i);
        }
        return years;
    }

    deleteEmptyObjectProperties(item) {
        for (let i in item) {
            if (item.hasOwnProperty(i) && (item[i] === '' || item[i] === null || item[i] === undefined)) {
                delete item[i];
            }
        }

        return item;
    }

    trimObjectData(item) {
        for (let i in item) {
            if (item.hasOwnProperty(i) && item[i] !== '' && item[i] != null && item[i] !== undefined && i !== 'password' && i !== 'rePassword') {
                if (item[i].replace) {
                    item[i] = item[i].replace(/\s+/g, ' ');
                }
                if (item[i].trim) {
                    item[i] = item[i].trim();
                }
            }
        }

        return item;
    }

    urlDataDecoded(data) {
        let searchParams = new URLSearchParams();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                searchParams.set(key, data[key] + '');
            }
        }
        return searchParams.toString();
    }

    errorHandle(error, msg) {
        if (error.parameterErrors) {
            for (let i = 0; i < error.parameterErrors.length; i++) {
                if (error.parameterErrors[i].message === 'NotAgree') {
                    error.parameterErrors[i].message = 'In order to register, you must agree to Terms & Conditions.';
                }
                msg.push({ severity: 'error', detail: error.parameterErrors[i].message });
            }
        } else {
            msg.push({ severity: 'error', detail: error.message });
        }
    }

    annualHouseholdIncome = [
        {label: 'Less than $50,000', value: 'LESS_50000'},
        {label: '$50,000 - $75,000', value: 'BETWEEN_50000_70000'},
        {label: '$75,000 - $100,000', value: 'BETWEEN_75000_10000'},
        {label: '$100,000 - $150,000', value: 'BETWEEN_100000_150000'},
        {label: '$150,000 - $200,000', value: 'BETWEEN_150000_200000'},
        {label: 'Over $200,000', value: 'OVER_200000'},
    ];

    homeOwner = [
        {label: 'Own', value: 'OWN'},
        {label: 'Rent', value: 'RENT'}
    ];

    householdMembers = [
        {label: '1', value: 'ONE'},
        {label: '2', value: 'TWO'},
        {label: '3', value: 'THREE'},
        {label: '4', value: 'FOUR'},
        {label: '5', value: 'FIVE'},
        {label: '6+', value: 'MORE_THAN_6'}
    ];

    states = [
        { value: '', label: 'Select...'},
        { value: 'AL', label: 'Alabama'},
        { value: 'AK', label: 'Alaska'},
        { value: 'AZ', label: 'Arizona'},
        { value: 'AR', label: 'Arkansas'},
        { value: 'CA', label: 'California'},
        { value: 'CO', label: 'Colorado'},
        { value: 'CT', label: 'Connecticut'},
        { value: 'DE', label: 'Delaware'},
        { value: 'DC', label: 'District Of Columbia'},
        { value: 'FL', label: 'Florida'},
        { value: 'GA', label: 'Georgia'},
        { value: 'HI', label: 'Hawaii'},
        { value: 'ID', label: 'Idaho'},
        { value: 'IL', label: 'Illinois'},
        { value: 'IN', label: 'Indiana'},
        { value: 'IA', label: 'Iowa'},
        { value: 'KS', label: 'Kansas'},
        { value: 'KY', label: 'Kentucky'},
        { value: 'LA', label: 'Louisiana'},
        { value: 'ME', label: 'Maine'},
        { value: 'MD', label: 'Maryland'},
        { value: 'MA', label: 'Massachusetts'},
        { value: 'MI', label: 'Michigan'},
        { value: 'MN', label: 'Minnesota'},
        { value: 'MS', label: 'Mississippi'},
        { value: 'MO', label: 'Missouri'},
        { value: 'MT', label: 'Montana'},
        { value: 'NE', label: 'Nebraska'},
        { value: 'NV', label: 'Nevada'},
        { value: 'NH', label: 'New Hampshire'},
        { value: 'NJ', label: 'New Jersey'},
        { value: 'NM', label: 'New Mexico'},
        { value: 'NY', label: 'New York'},
        { value: 'NC', label: 'North Carolina'},
        { value: 'ND', label: 'North Dakota'},
        { value: 'OH', label: 'Ohio'},
        { value: 'OK', label: 'Oklahoma'},
        { value: 'OR', label: 'Oregon'},
        { value: 'PA', label: 'Pennsylvania'},
        { value: 'RI', label: 'Rhode Island'},
        { value: 'SC', label: 'South Carolina'},
        { value: 'SD', label: 'South Dakota'},
        { value: 'TN', label: 'Tennessee'},
        { value: 'TX', label: 'Texas'},
        { value: 'UT', label: 'Utah'},
        { value: 'VT', label: 'Vermont'},
        { value: 'VA', label: 'Virginia'},
        { value: 'WA', label: 'Washington'},
        { value: 'WV', label: 'West Virginia'},
        { value: 'WI', label: 'Wisconsin'},
        { value: 'WY', label: 'Wyoming'}
    ];

    formatPhone(event, phone, input) {
    if (event.key !== 'Tab') {
        let tmp = '';
        for (let i = 0; i < phone.length; i++) {
            if (phone[i] >= '0' && phone[i] <= '9') {
                tmp += phone[i];
            }
        }
        if (!tmp) {
            phone = input = '';
            return input;
        }
        if (tmp.length < 3) {
            phone = input = '(' + tmp;
            return input;
        }

        phone = '(' + tmp.substr(0, 3);
        tmp = tmp.substr(3);

        if (tmp.length) {
            phone += ') ';
        }
        for (let i = 0; i < tmp.length; i++) {
            if (i < 3) {
                // console.log('1', tmp.substring(i, i + 1));
                phone += tmp.substring(i, i + 1);
            } else if (i % 4 === 3) {
                phone += '-';
                // console.log('2', tmp.substring(i, i + 1));
                phone += tmp.substring(i, i + 1);
            } else {
                // console.log('3', tmp.substring(i, i + 1));
                phone += tmp.substring(i, i + 1);
            }
        }
        input = phone;
    }
    return input;
}

    // hold the shopping cart for 2 hours in a cookie with truncated products
    truncateProd(p) {
        return {
           id:  p.id,
           qty:  p.qty,
           market: p.market
       };
    }

    clearCart() {
        localStorage.removeItem('cart_for_axxess_shopping');
    }

    saveCartToCookies(cart) {
        localStorage.removeItem('cart_for_axxess_shopping');

        if (cart.hasOwnProperty('value')) {
            cart = cart['value'];
        }

        cart.forEach(item => {
            Object.keys(item).forEach(key => {
               if (key.toLowerCase().includes('plain')) {
                   delete item[key];
               }
            });
        });
        const object = {value: cart, timestamp: new Date().getTime()};
        localStorage.setItem('cart_for_axxess_shopping', encodeURIComponent(JSON.stringify(object)));
    }

    getCartFromCookies() {
        let result: any = localStorage.getItem('cart_for_axxess_shopping');
        if (result) {
            result = JSON.parse(decodeURIComponent(result));
            if (result.hasOwnProperty('value')) {
                // CHECK IF EXPIRED
                let expiryDate = new Date(result['timestamp']);
                let currentDate = new Date();
                expiryDate.setHours(expiryDate.getHours() + EXPIRATION_HOURS);
                if (currentDate.getTime() < expiryDate.getTime()) {
                    result = result['value'];
                } else {
                    this.clearCart();
                    return;
                }
            }
            this.saveCartToCookies(result);
        }
        return result;
    }
    // END hold the shopping cart for 2 hours in a cookie

    addCache(cname, cvalue, time) {
        const cookieExpiry: number = Date.now() + time * 1000;
        return this._cookieService.put(cname, cvalue, { expires: new Date(cookieExpiry) });
    }

    getCache(cname){
        return this._cookieService.get(cname);
    }

    remCache(cname){
        return this._cookieService.remove(cname);
    }

    isValidPhone(phone) {
        // under 6  - not saving all valid
        if (phone.length < 6) {
            return true;
        }

        // the length is not valid - we dont care about the symbols
        if (phone.length < 9) {
            return false;
        }

        // validate first digits
        if ( phone[0] !== '(' || phone[4] !== ')' ||
            (phone[1] < '0' || phone[1] > '9') ||
            (phone[2] < '0' || phone[2] > '9') ||
            (phone[3] < '0' || phone[3] > '9')  ) {
            return false
        }

        // validate after the code
        for (let i = 6; i < phone.length; i++){
            if (phone[i] < '0' || phone[i] > '9') {
                if (phone[i] !== ' ' && phone[i] !== '-') {
                    return false;
                }
            }
        }
        return true;
    }

    formatDate(date) {
        return Number(date.substr(5, 2)) + '/' + Number(date.substr(8, 2)) + '/' + date.substr(2, 2);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/common-data.service.ts